import axios from "axios";
import { Report } from "../../types/models"; // Adjust the import to match your project structure
const REACT_APP_API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

interface GenerateReportPayload {
  account_root_id: number;
  billing_month: string; // Format: "YYYY-MM"
}

export const generateReport = async (
  payload: GenerateReportPayload
): Promise<Report> => {
  const token = localStorage.getItem("authToken");

  if (!token) {
    throw new Error("Unauthorized: No token found.");
  }

  try {
    const response = await axios.post(
      `${REACT_APP_API_URL}/report/generate`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error generating report:", error);
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.detail || "Failed to generate report.");
    }
    throw new Error("An unexpected error occurred.");
  }
};
